import { fetchWeb3AuthSession } from './web3Auth';

/**
 * Whether the browser has an active sovereign Web3 session cookie.
 */
export const checkWeb3Session = () =>
  fetchWeb3AuthSession()
    .then(session => Boolean(session?.authenticated))
    .catch(() => false);

/**
 * Guest can proceed when Sharetribe session OR Web3 session is present.
 */
export const hasEffectiveSession = ({ isSharetribeAuthenticated, hasWeb3Session }) =>
  Boolean(isSharetribeAuthenticated || hasWeb3Session);
